<!--
 * @Author: Zj
 * @Date: 2022-01-14 16:30:55
 * @LastEditTime: 2023-06-13 20:11:21
 * @LastEditors: zj
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gdp-cloud-app\src\components\business\mdt-consult\c-mdt\attend-list.vue
-->
<template>
  <div class="attendList">
    <div class="wholePart" v-for='(item,index) in attendList' :key='index'>
      <div class="imgHead">
        <img src='../../../../assets/headimg.png' />
      </div>
      <div class="info">
        <div class="name">{{item.userTrueName}}</div>
        <div class="phoneAdress">
          <div class="phone">
            <img src='../../../../assets/ic_phone@2x.png' />
            <span>{{item.userAccount}}</span>
          </div>
          <div class="adress">
            <img src='../../../../assets/ic_hospitalinfo@2x.png' />
            <span>{{item.userOrganizationName}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      attendList: []
    };
  },
  created () {
    this.getAttendList();
  },
  methods: {
    getAttendList () {
      this.$axios
        .post('edu/home/page/user/page/list', {
          data: {
            current: 1,
            dataId: this.$route.query.dataId,
            moduleId: this.$route.query.moduleId,
            size: 10
          },
          version: this.$version
        })
        .then((res) => {
          if (res.status) {
            this.attendList = res.data.list;
          }
        });
    }
  }
};
</script>
<style lang='scss' scoped>
.wholePart{
    overflow: hidden;
    margin-bottom:35px;
    display: flex;
}
.imgHead {
  float: left;
  clear: both;
  margin: 0 16px;
  img {
    width: 34px;
  }
}
.info {
  float: left;
  .name {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    margin-bottom: 2px;
    font-weight: 500;
  }
  .phoneAdress {
    overflow: hidden;
    display: flex;
    .phone {
      flex-shrink: 0;
      margin-right: 24px;
      img{
          width:16px;
      }
      span {
        font-size: 14px;
        color: #999999;
        letter-spacing: 0;
        font-weight: 400;
      }
    }
    .adress {
      img {
        width: 16px;
      }
      span {
        font-size: 14px;
        color: #999999;
        letter-spacing: 0;
        font-weight: 400;
      }
    }
  }
}
</style>
